import gql from 'graphql-tag';

export default gql`
  fragment EnvoyErrorsFragment on EnvoyError {
    code
    domain
  }
`;
